export const DELIVERY_SERVICE_TYPES = ['delivery_taxi', 'delivery_novaposhta', 'delivery_own']
export const TAKEOUT_SERVICE_TYPE = 'takeaway'
export const HERE_SERVICE_TYPE = 'here'
